import { Address } from '../models/Address';

import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';
import { FULFILLMENT_ADDRESS_VALIDATION_URL } from 'common/api/config';

export interface AddressValidationResult {
    hasSuggestions: boolean;
    wasAddressFound: boolean;
    suggestedAddress: Address | null;
}

export const validateAddress = (address: Address) =>
    withTokensIfNeeded<AddressValidationResult>(FULFILLMENT_ADDRESS_VALIDATION_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(address),
    });
